import { Text } from '../../cdl/Text/Text';
import { Characters } from '../../common/helpers/unicode.helper';

interface OfferCountProps {
    offerCount: number;
}

export const OfferCount = ({ offerCount }: OfferCountProps) => {
    return <Text>{offerCount > 0 ? offerCount : Characters.EN_DASH}</Text>;
};
